
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 48.5C5 50.9844 7.01562 53 9.5 53H54.5C56.9844 53 59 50.9844 59 48.5V32H5V48.5ZM23 42.125C23 41.5063 23.5063 41 24.125 41H36.875C37.4937 41 38 41.5063 38 42.125V45.875C38 46.4937 37.4937 47 36.875 47H24.125C23.5063 47 23 46.4937 23 45.875V42.125ZM11 42.125C11 41.5063 11.5063 41 12.125 41H18.875C19.4937 41 20 41.5063 20 42.125V45.875C20 46.4937 19.4937 47 18.875 47H12.125C11.5063 47 11 46.4937 11 45.875V42.125ZM59 15.5V20H5V15.5C5 13.0156 7.01562 11 9.5 11H54.5C56.9844 11 59 13.0156 59 15.5Z","fill":"currentColor"}})])
          )
        }
      }
    